module.exports = __webpack_public_path__ + "static/Testimonial_Andre_Sander-4116d65f791d1edb3efcdf82cc7394f9.png";